import type {
  DeviceAssociationGetAllResponse,
  DeviceAssociationSearchParams,
  DeviceAssociationWithId,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class DeviceAssociationApi {
  public async getDeviceAssociations(
    params: DeviceAssociationSearchParams,
  ): Promise<DeviceAssociationGetAllResponse> {
    return await trpcClient.device.usage.getAll.query(params);
  }

  public async createDeviceAssociation(
    device: string,
    patient: string,
  ): Promise<DeviceAssociationWithId> {
    return await trpcClient.device.usage.create.mutate({
      device,
      patient,
    });
  }

  public terminateDeviceUseStatement = async (id: string): Promise<void> => {
    await trpcClient.device.usage.terminate.mutate({ id });
  };

  public cancelDeviceUseStatement = async (id: string): Promise<void> => {
    await trpcClient.device.usage.cancel.mutate({ id });
  };
}
